import { render, staticRenderFns } from "./PublicBeranda.vue?vue&type=template&id=55360f56&"
import script from "./PublicBeranda.vue?vue&type=script&lang=js&"
export * from "./PublicBeranda.vue?vue&type=script&lang=js&"
import style0 from "./PublicBeranda.vue?vue&type=style&index=0&id=55360f56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports